import script from "./upgrade-maintenance-detail.vue?vue&type=script&lang=ts&setup=true"
export * from "./upgrade-maintenance-detail.vue?vue&type=script&lang=ts&setup=true"

import "./upgrade-maintenance-detail.vue?vue&type=style&index=0&id=7f453a7c&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f453a7c"]])

export default __exports__